/* tslint:disable */

/**
 */
export class StartCalculate {
    tempPtIn?: number;
    idStudy?: number;
    checkOptim?: number;
    epsilonTemp?: number;
    epsilonEnth?: number;
    nbOptimIter?: number;
    sdisableOptim?: number;
    timeStep?: number;
    precision?: number;
    scheckStorage?: number;
    storagestep?: number;
    hRadioOn?: number;
    hRadioOff?: number;
    maxIter?: number;
    relaxCoef?: number;
    vRadioOn?: number;
    vRadioOff?: number;
    tempPtSurf?: number;
    idStudyEquipment?: number;
    tempPtBot?: number;
    tempPtAvg?: number;
    seValue1?: number;
    seValue2?: number;
    seValue3?: number;
    seValue4?: number;
    seValue5?: number;
    seValue6?: number;
    seValue7?: number;
    seValue8?: number;
    seValue9?: number;
    sdisableFields?: number;
    sdisableCalculate?: number;
    sdisableNbOptim?: number;
    sdisableTimeStep?: number;
    sdisablePrecision?: number;
    sdisableStorage?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/start-calculate.ts